module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[89]210.9e53e61.woff2";